const alerts = [
  {
    id: 1,
    type: 'critical',
    title: 'Documentación pendiente',
    description: 'OP-2024-1847 requiere certificado de origen',
    time: '15 min',
  },
  {
    id: 2,
    type: 'warning',
    title: 'Pago próximo a vencer',
    description: 'Factura FC-2024-0892 vence en 2 días',
    time: '1 hora',
  },
  {
    id: 3,
    type: 'info',
    title: 'Operación completada',
    description: 'OP-2024-1823 liberada exitosamente',
    time: '3 horas',
  },
  {
    id: 4,
    type: 'critical',
    title: 'Demora en aduana',
    description: 'OP-2024-1856 detenida en revisión',
    time: '5 horas',
  },
];

const typeConfig = {
  critical: { bg: 'bg-red-50', icon: 'ri-error-warning-line', iconColor: 'text-[#EF4444]' },
  warning: { bg: 'bg-yellow-50', icon: 'ri-alert-line', iconColor: 'text-[#EAB308]' },
  info: { bg: 'bg-[#EAF2F8]', icon: 'ri-information-line', iconColor: 'text-[#2F80ED]' },
};

export default function AlertsPanel() {
  return (
    <div className="bg-white rounded-lg p-6 border border-gray-200 h-full">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-[#0A2A43]">Alertas Críticas</h3>
        <span className="px-2 py-1 text-xs font-semibold bg-[#EF4444] text-white rounded-full">
          {alerts.filter(a => a.type === 'critical').length}
        </span>
      </div>

      <div className="space-y-3">
        {alerts.map((alert) => {
          const config = typeConfig[alert.type as keyof typeof typeConfig];
          return (
            <div
              key={alert.id}
              className={`${config.bg} rounded-lg p-4 hover:shadow-sm transition-shadow cursor-pointer`}
            >
              <div className="flex gap-3">
                <div className={`w-8 h-8 rounded-full bg-white flex items-center justify-center ${config.iconColor}`}>
                  <i className={`${config.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-[#0A2A43]">{alert.title}</p>
                  <p className="text-xs text-[#6B7280] mt-1">{alert.description}</p>
                  <p className="text-xs text-[#6B7280] mt-2">Hace {alert.time}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button className="w-full mt-4 py-2 text-sm font-medium text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors cursor-pointer whitespace-nowrap">
        Ver todas las alertas
      </button>
    </div>
  );
}